<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="codigo.estatus"
    persistent
    max-width="400"
  >

    <v-card>
      <v-card-title class="text-h5">
        ¡Excelente!
      </v-card-title>
      <v-card-text class="text-subtitle-1">
        Antes de continuar con tu examen, te recomendamos descargar las intrucciones para presentar tu examen, 
        una vez hecho esto, da clic en "Presentar mi examen" para redirigirte el. <strong>¡Suerte!</strong>
        <br/>
        <br/>
        <div class="text-center text-h4">
          <strong>{{ codigo.codigo }}</strong>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="abrirManual( )"
          dark
          class="text-capitalize"
        >
          Descargar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          @click="abrirExamen( )"
          dark
          class="text-capitalize"
        >
          Presentar examen
        </v-btn>
      </v-card-actions>
      <v-btn 
        @click="codigo.estatus = false"
        icon
        absolute
        top
        right
        class="mt-n3"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>


<script>
	export default {
		props:[
			'codigo'
	  ],

    methods:{
      abrirManual( ){
        this.codigo.estatus = false
        window.open( this.codigo.manual )
      },

      abrirExamen( ){
        this.codigo.estatus = false
        window.open( this.codigo.ruta )
      }
    }
	}
</script>